import { Stack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)<StackProps>(
  ({ theme: { spacing, palette, customVars } }) => ({
    gap: spacing(3.2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'fit-content',
    padding: spacing(1.4, 1.6),
    marginBottom: spacing(0.2),
    backgroundColor: palette.common.white,
    boxShadow: customVars.dropDownShadow,
    '& .date': {
      minWidth: spacing(45),
    },
    '& .feature-name': {
      minWidth: spacing(25),
      textAlign: 'left',
    },
    '& .edit-feature-flag-btn': {
      minWidth: spacing(15),
    },
    '& .enable-feature-flag': {
      minWidth: spacing(13),
      marginLeft: 'auto',
      color: palette.text.primary,
    },
  })
);
